import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applicableToFilter,
  setApplicableToFilter,
  applyFilters,
  removeFilters,
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group controlId="applicableToFilter">
            <Form.Label>Applicable To</Form.Label>

            <Form.Control
              as="select"
              value={applicableToFilter}
              onChange={(e) => setApplicableToFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="Vehicle">Vehicle</option>
              <option value="Client">Client</option>
              <option value="Lease">Lease</option>
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>

        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
